module.exports = __webpack_public_path__ + "../../img/device-error-update.png";